import Card08 from "../Card/Card08";
import axios from "axios";
import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useParams } from "react-router-dom";

const UUHukumContent = () => {
  let { search } = useParams();
  const [items, setItems] = useState([]);
  const [urlpath, setUrlpath] = useState([]);
  const [pageCount, setpageCount] = useState(0);

  useEffect(() => {
    if (search === undefined) {
      const url = `https://divhubinter.polri.go.id/api/view_uuh?page=1`;

      const getComments = async () => {
        const res = await axios.get(url);

        // const total = res.headers.get("x-total-count");
        setpageCount(
          Math.ceil(res.data.uuhukum.total / res.data.uuhukum.per_page),
        );
        setUrlpath(res.data.uuhukum.path);
        setItems(res.data.uuhukum.data);
      };

      getComments();
    } else {
      const url = `https://divhubinter.polri.go.id/api/dhi_search/` + search;

      const getComments = async () => {
        const res = await axios.get(url);
        // const total = res.headers.get("x-total-count");
        setpageCount(Math.ceil(res.data.total / res.data.per_page));
      };

      getComments();
    }
  }, [search]);

  const fetchComments = async (currentPage) => {
    const url = urlpath + `?page=${currentPage}`;

    const res = await axios.get(url);
    if (search === undefined) {
      const data = await res.data.uuhukum.data;
      setItems(data);

      return data;
    } else {
      const data = await res.data.data;
      setItems(data);

      return data;
    }
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;

    const commentsFormServer = await fetchComments(currentPage);

    setItems(commentsFormServer);
  };
  return (
    <div>
      <div className="mx-auto w-11/12 laptop:max-w-full desktop:max-w-7xl ">
        <div className="laptop:grid py-12">
          <h2 className="text-4xl font-bold text-left uppercase pb-8">
            UU & Hukum
          </h2>
          <Card08 UUHukumHighlights={items} />
          <br />
          <br />
          <ReactPaginate
            className={"flex justify-center space-x-2"}
            previousLabel="&laquo;"
            nextLabel="&raquo;"
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"btn-group "}
            pageClassName={"btn rounded-none "}
            previousClassName={"join-item btn btn-outline "}
            nextClassName={"join-item btn btn-outline"}
            breakClassName={"btn btn-disabled"}
            activeClassName={"btn-active"}
          />
        </div>
      </div>
    </div>
  );
};

export default UUHukumContent;
